<template>
<div class="fill ofy" @scroll="OnScroll($event)" ref="container">
    <slot></slot>
</div>
</template>

<script>
export default {
    props: {
        list: {
            type: [Array, Object],
            default: null
        }
    },
    data() {
        return {
            lastBottom: 0,
            resetFlag: false,
            reachBottomFlag: false,
        }
    },
    methods: {
        Reset() {
            this.lastBottom = 0;
            this.resetFlag = true;
            setTimeout(() => {
                this.resetFlag = false;
            }, 100);
        },
        OnScroll(e) {
            if(this.resetFlag) return this.resetFlag = false;;
            if(this.reachBottomFlag) return;
            var bottom = Math.ceil(this.$refs.container.offsetHeight + this.$refs.container.scrollTop);
            if(this.lastBottom !== bottom && bottom >= this.$refs.container.scrollHeight && bottom > this.lastBottom)
            {
                this.reachBottomFlag = true;
                setTimeout(() => {
                    this.reachBottomFlag = false;
                }, 100);
                this.lastBottom = bottom;
                this.$emit('OnBottom');
            }
        }
    },
    watch: {
        list: function(n, o) 
        {
            if(n && o && n.length > o.length)
                this.Reset();
        }
    }
}
</script>